import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireJobManager?: boolean;
  requireQRCodeManager?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireAdmin = false, 
  requireJobManager = false,
  requireQRCodeManager = false
}) => {
  const { isAuthenticated, isAdmin, isJobManager, isQRCodeManager } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/volunteer/dashboard" replace />;
  }

  if (requireJobManager && !isJobManager) {
    return <Navigate to="/volunteer/dashboard" replace />;
  }

  if (requireQRCodeManager && !isQRCodeManager) {
    return <Navigate to="/volunteer/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
